import { ConfigAttribute } from './ConfigAttribute';

export enum ConfigKeys {
  SYSTEM = 0,
  WHATSAPP = 1,
  TWITTER = 2,
}



export class Config {
  id!: number;
  key!: ConfigKeys;
  name!: string;
  attributes?: ConfigAttribute[];
} 